export default "#define GLSLIFY 1\nvoid main()\n{\n    gl_Position = vec4(position, 1.0);\n}";